var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require("@/assets/imgs/dt.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v(" 公交线路:"),_c('br')])])
}]

export { render, staticRenderFns }